export default __webpack_public_path__ + "static/media/Martin Cullen.a56d61e8.jpg";